"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    color: 'gray.800',
    borderRadius: 'full',
    backgroundColor: 'gray.100',
    _disabled: {
        backgroundColor: 'gray.50',
    },
    _hover: {
        backgroundColor: 'gray.200',
    },
    _active: {
        backgroundColor: 'gray.300',
    },
};
const CloseButtonStyle = {
    baseStyle,
};
exports.default = CloseButtonStyle;
